module.exports = __webpack_public_path__ + "img/slovakia.8f908a8a.svg";